import React, { useState } from 'react';
import { Play, TrendingUp, TrendingDown } from 'lucide-react';

const RealEstateDistribution = () => {
  const [totalFilter, setTotalFilter] = useState('last 6 month');
  const [viewingTimeFilter, setViewingTimeFilter] = useState('month');
  const [propertiesViewedFilter, setPropertiesViewedFilter] = useState('month');

  return (
    <div className="min-h-screen bg-black text-white p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-4xl font-bold mb-1">Distribution Analytics</h1>
        <p className="text-gray-400 text-sm">Real Estate - Property Performance Overview</p>
      </div>

      {/* Row 1: Total, Viewing Time, Properties Viewed */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        {/* Total Card */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Total</h2>
            <div className="flex gap-2 text-xs">
              <button className={`px-3 py-1 rounded ${totalFilter === 'last 6 month' ? 'bg-gray-700' : 'bg-gray-800'}`} onClick={() => setTotalFilter('last 6 month')}>last 6 month</button>
              <button className={`px-3 py-1 rounded ${totalFilter === '2024' ? 'bg-gray-700' : 'bg-gray-800'}`} onClick={() => setTotalFilter('2024')}>2024</button>
            </div>
          </div>
          <div className="flex items-center gap-2 mb-6">
            <p className="text-5xl font-bold">8.2M</p>
            <Play size={20} className="text-blue-400" />
          </div>
          
          <div className="space-y-3">
            <div>
              <p className="text-xs text-gray-400">Top Property</p>
              <p className="text-sm font-semibold">Skyline Tower Penthouse</p>
              <p className="text-xs text-gray-500">256 viewings</p>
            </div>
            <div>
              <p className="text-xs text-gray-400">Top Agent</p>
              <p className="text-sm font-semibold">Sarah Mitchell</p>
              <p className="text-xs text-gray-500">1.3M property views</p>
            </div>
            <div>
              <p className="text-xs text-gray-400">Most Searched</p>
              <p className="text-sm font-semibold">Luxury Condos Downtown</p>
              <p className="text-xs text-gray-500">423 searches</p>
            </div>
          </div>
        </div>

        {/* Viewing Time Card */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Viewing time</h2>
            <div className="flex gap-2 text-xs">
              <button className={`px-2 py-1 rounded ${viewingTimeFilter === 'month' ? 'bg-gray-700' : 'bg-gray-800'}`} onClick={() => setViewingTimeFilter('month')}>month</button>
              <button className={`px-2 py-1 rounded ${viewingTimeFilter === 'week' ? 'bg-gray-700' : 'bg-gray-800'}`} onClick={() => setViewingTimeFilter('week')}>week</button>
              <button className={`px-2 py-1 rounded ${viewingTimeFilter === 'today' ? 'bg-gray-700' : 'bg-gray-800'}`} onClick={() => setViewingTimeFilter('today')}>today</button>
            </div>
          </div>
          <div className="mb-2">
            <p className="text-sm text-gray-400">average time <span className="text-2xl font-bold text-white">45 minutes</span></p>
            <p className="text-green-400 text-sm flex items-center gap-1">
              <TrendingUp size={16} />
              +62.3%
            </p>
          </div>
          {/* Bar Chart */}
          <div className="flex items-end gap-1 h-32">
            {[40, 55, 48, 62, 45, 70, 52, 58, 45, 68, 55, 50, 65, 48, 72, 60, 55, 58, 62, 55, 68, 52, 48, 70, 58, 62, 55, 68, 52, 45].map((height, i) => (
              <div key={i} className="flex-1 bg-green-500 rounded-t" style={{ height: `${height}%` }}></div>
            ))}
          </div>
          <p className="text-xs text-gray-500 mt-2">last update 21:37</p>
        </div>

        {/* Properties Viewed Card */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Properties Viewed</h2>
            <div className="flex gap-2 text-xs">
              <button className={`px-2 py-1 rounded ${propertiesViewedFilter === 'month' ? 'bg-gray-700' : 'bg-gray-800'}`} onClick={() => setPropertiesViewedFilter('month')}>month</button>
              <button className={`px-2 py-1 rounded ${propertiesViewedFilter === 'week' ? 'bg-gray-700' : 'bg-gray-800'}`} onClick={() => setPropertiesViewedFilter('week')}>week</button>
              <button className={`px-2 py-1 rounded ${propertiesViewedFilter === 'today' ? 'bg-gray-700' : 'bg-gray-800'}`} onClick={() => setPropertiesViewedFilter('today')}>today</button>
            </div>
          </div>
          <div className="mb-2">
            <p className="text-sm text-gray-400">average views <span className="text-2xl font-bold text-white">1,245</span></p>
            <p className="text-red-400 text-sm flex items-center gap-1">
              <TrendingDown size={16} />
              -18.12%
            </p>
          </div>
          {/* Bar Chart */}
          <div className="flex items-end gap-1 h-32">
            {[65, 58, 70, 52, 68, 45, 72, 55, 62, 58, 68, 50, 65, 58, 48, 70, 55, 62, 58, 68, 52, 65, 58, 70, 55, 62, 48, 68, 58, 65].map((height, i) => (
              <div key={i} className="flex-1 bg-cyan-500 rounded-t" style={{ height: `${height}%` }}></div>
            ))}
          </div>
          <p className="text-xs text-gray-500 mt-2">last update 22:08</p>
        </div>
      </div>

      {/* Row 2: Session Time, Property Type Chart, Location */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        {/* Session Time */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Session Time</h2>
            <div className="flex gap-2 text-xs">
              <button className="px-3 py-1 rounded bg-gray-700">last month</button>
              <button className="px-3 py-1 rounded bg-gray-800">All</button>
            </div>
          </div>
          <div className="mb-4">
            <p className="text-sm text-gray-400 mb-1">52 times</p>
            <p className="text-sm text-gray-400">186 average time</p>
          </div>
          <div className="space-y-2 mb-4">
            <div className="flex items-center justify-between text-xs">
              <span className="text-gray-400">0-20</span>
              <div className="flex-1 mx-2 bg-gray-800 h-8 rounded relative overflow-hidden">
                <div className="absolute left-0 top-0 bottom-0 bg-red-500 w-3/4"></div>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs">
              <span className="text-gray-400">20-40</span>
              <div className="flex-1 mx-2 bg-gray-800 h-8 rounded relative overflow-hidden">
                <div className="absolute left-0 top-0 bottom-0 bg-green-500 w-4/5"></div>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs">
              <span className="text-gray-400">1h-2h</span>
              <div className="flex-1 mx-2 bg-gray-800 h-8 rounded relative overflow-hidden">
                <div className="absolute left-0 top-0 bottom-0 bg-gray-500 w-1/2"></div>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs">
              <span className="text-gray-400">2h-4h</span>
              <div className="flex-1 mx-2 bg-gray-800 h-8 rounded relative overflow-hidden">
                <div className="absolute left-0 top-0 bottom-0 bg-gray-500 w-1/3"></div>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs">
              <span className="text-gray-400">4h+</span>
              <div className="flex-1 mx-2 bg-gray-800 h-8 rounded relative overflow-hidden">
                <div className="absolute left-0 top-0 bottom-0 bg-gray-500 w-1/4"></div>
              </div>
            </div>
          </div>
          <div className="flex gap-4 text-xs">
            <div className="flex items-center gap-1"><div className="w-3 h-3 bg-green-500 rounded"></div> MAX</div>
            <div className="flex items-center gap-1"><div className="w-3 h-3 bg-red-500 rounded"></div> MIN</div>
            <div className="flex items-center gap-1"><div className="w-3 h-3 bg-gray-500 rounded"></div> Other</div>
          </div>
        </div>

        {/* Property Type Chart */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Property Type Chart</h2>
            <div className="flex gap-2 text-xs">
              <button className="px-2 py-1 rounded bg-gray-700">last week</button>
              <button className="px-2 py-1 rounded bg-gray-800">All</button>
              <button className="px-2 py-1 rounded bg-gray-800 text-blue-400">see all</button>
            </div>
          </div>
          {/* Donut Chart */}
          <div className="relative w-48 h-48 mx-auto mb-4">
            <svg viewBox="0 0 100 100" className="transform -rotate-90">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#3b82f6" strokeWidth="12" strokeDasharray="175.84 251.2" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#10b981" strokeWidth="12" strokeDasharray="100.48 351.76" strokeDashoffset="-175.84" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#eab308" strokeWidth="12" strokeDasharray="62.8 364.32" strokeDashoffset="-276.32" />
              <circle cx="50" cy="50" r="40" fill="none" stroke="#6b7280" strokeWidth="12" strokeDasharray="40 389.12" strokeDashoffset="-339.12" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <p className="text-3xl font-bold">42%</p>
            </div>
          </div>
          <p className="text-sm text-gray-400 mb-2">Selected type: Condos</p>
          <div className="grid grid-cols-2 gap-2 text-xs mb-4">
            <div><span className="text-gray-400">viewing time</span> <span className="font-bold">3.8M</span></div>
            <div><span className="text-gray-400">properties added</span> <span className="font-bold">156</span></div>
            <div><span className="text-gray-400">properties viewed</span> <span className="font-bold">2,341</span></div>
          </div>
          <div className="space-y-1 text-xs">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2"><div className="w-3 h-3 rounded-full bg-blue-500"></div> Condos</div>
              <span>42% (42x)</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2"><div className="w-3 h-3 rounded-full bg-green-500"></div> Houses</div>
              <span>28% (28x)</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2"><div className="w-3 h-3 rounded-full bg-yellow-500"></div> Apartments</div>
              <span>20% (20x)</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2"><div className="w-3 h-3 rounded-full bg-gray-500"></div> Other</div>
              <span>10% (10x)</span>
            </div>
          </div>
        </div>

        {/* Location */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Location</h2>
            <div className="flex gap-2 text-xs">
              <button className="px-2 py-1 rounded bg-gray-700">last month</button>
              <button className="px-2 py-1 rounded bg-gray-800">2024</button>
              <button className="px-2 py-1 rounded bg-gray-800 text-blue-400">see all</button>
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-semibold">New York, NY</span>
                <span className="text-xs text-gray-400">52x / 100</span>
              </div>
              <div className="w-full bg-gray-800 h-2 rounded-full overflow-hidden">
                <div className="bg-blue-500 h-full" style={{ width: '52%' }}></div>
              </div>
              <p className="text-xs text-gray-400 mt-1">Viewed in minutes 12.8M</p>
            </div>
            <div>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-semibold">Los Angeles, CA</span>
                <span className="text-xs text-gray-400">38x / 100</span>
              </div>
              <div className="w-full bg-gray-800 h-2 rounded-full overflow-hidden">
                <div className="bg-blue-500 h-full" style={{ width: '38%' }}></div>
              </div>
              <p className="text-xs text-gray-400 mt-1">Viewed in minutes 8.5M</p>
            </div>
            <div>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-semibold">Miami, FL</span>
                <span className="text-xs text-gray-400">24x / 100</span>
              </div>
              <div className="w-full bg-gray-800 h-2 rounded-full overflow-hidden">
                <div className="bg-blue-500 h-full" style={{ width: '24%' }}></div>
              </div>
              <p className="text-xs text-gray-400 mt-1">Viewed in minutes 5.2M</p>
            </div>
            <div>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-semibold">Other</span>
                <span className="text-xs text-gray-400">12x / 100</span>
              </div>
              <div className="w-full bg-gray-800 h-2 rounded-full overflow-hidden">
                <div className="bg-blue-500 h-full" style={{ width: '12%' }}></div>
              </div>
              <p className="text-xs text-gray-400 mt-1">Viewed in minutes 2.1M</p>
            </div>
          </div>
        </div>
      </div>

      {/* Row 3: Top Properties, Graph of New Listings, Top Agents */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Top Properties */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Top Properties</h2>
            <div className="flex gap-2 text-xs">
              <button className="px-2 py-1 rounded bg-gray-700">last week</button>
              <button className="px-2 py-1 rounded bg-gray-800 text-blue-400">see all</button>
            </div>
          </div>
          <div className="mb-4">
            <div className="w-full h-32 bg-gradient-to-br from-purple-600 to-pink-600 rounded-lg flex items-center justify-center mb-3">
              <div className="text-6xl">🏢</div>
            </div>
            <h3 className="font-bold text-lg">Marina Bay Residences</h3>
            <p className="text-xs text-gray-400 mb-2">Luxury Waterfront • 2023 • Condos</p>
            <p className="text-xs text-gray-400">48 units (avg $2.8M)</p>
          </div>
          <div className="grid grid-cols-2 gap-2 text-xs">
            <div><span className="text-gray-400">viewing time</span> <span className="font-bold">8,542</span></div>
            <div><span className="text-gray-400">inquiries</span> <span className="font-bold">287</span></div>
            <div><span className="text-gray-400">total views</span> <span className="font-bold">1,893</span></div>
          </div>
        </div>

        {/* Graph of New Listings */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Graph of New Listings</h2>
            <div className="flex gap-2 text-xs">
              <button className="px-2 py-1 rounded bg-gray-700">last month</button>
              <button className="px-2 py-1 rounded bg-gray-800">2024</button>
              <button className="px-2 py-1 rounded bg-gray-800 text-blue-400">see all</button>
            </div>
          </div>
          <div className="mb-4">
            <div className="flex gap-4 text-xs mb-2">
              <div className="flex items-center gap-1"><div className="w-3 h-3 bg-blue-500 rounded"></div> New Listings</div>
              <div className="flex items-center gap-1"><div className="w-3 h-3 bg-green-500 rounded"></div> New (%)</div>
              <div className="flex items-center gap-1"><div className="w-3 h-3 bg-gray-500 rounded"></div> Old Listings</div>
            </div>
            {/* Line Chart Placeholder */}
            <div className="h-32 flex items-end justify-between gap-1">
              {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map((month, i) => (
                <div key={month} className="flex-1 flex flex-col items-center">
                  <div className="w-full h-20 relative">
                    <div className="absolute bottom-0 w-full h-1/2 bg-blue-500 opacity-20"></div>
                  </div>
                  <span className="text-[8px] text-gray-500 mt-1">{month}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="text-xs space-y-1">
            <p className="text-gray-400">MIN and MAX values</p>
            <p className="text-gray-400">min new 18.3x max new</p>
            <p className="text-gray-400">min old 42.7x max old</p>
            <p className="text-white font-bold">23% total new</p>
          </div>
        </div>

        {/* Top Agents */}
        <div className="bg-black border-2 border-gray-400 rounded-lg p-6 hover:border-white hover:shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all duration-300">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Top Agents</h2>
            <div className="flex gap-2 text-xs">
              <button className="px-2 py-1 rounded bg-gray-700">last 6 month</button>
              <button className="px-2 py-1 rounded bg-gray-800">All</button>
              <button className="px-2 py-1 rounded bg-gray-800 text-blue-400">see all</button>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <span className="text-gray-400">1</span>
                <span>Sarah Mitchell</span>
              </div>
              <span className="font-semibold">52,338</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <span className="text-gray-400">2</span>
                <span>Michael Chen</span>
                <TrendingUp size={12} className="text-green-400" />
              </div>
              <span className="font-semibold">38,742</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <span className="text-gray-400">3</span>
                <span>Jennifer Davis</span>
                <TrendingDown size={12} className="text-red-400" />
              </div>
              <span className="font-semibold">32,156</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <span className="text-gray-400">4</span>
                <span>David Martinez</span>
              </div>
              <span className="font-semibold">28,945</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <span className="text-gray-400">5</span>
                <span>Emily Johnson</span>
                <TrendingUp size={12} className="text-green-400" />
              </div>
              <span className="font-semibold">24,873</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealEstateDistribution;
